import swal from "sweetalert";

export const showLoading = () => {
  if (!swal.getState?.().isOpen) {
    swal({
      title: "Sedang memproses data...",
      // text: "Mohon tunggu",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <div style="display:flex;justify-content:center;margin-top:15px;">
              <div class="swal-loader"></div>
            </div>
          `,
        },
      },
    });
  }
};

export const hideLoading = () => {
  if (swal.getState?.().isOpen) {
    swal.close();
  }
};
